import { Genders } from 'app/core/enums';

export const GENDER_LIST_CONFIGS = [
  {
    key: Genders.Male,
    title: 'general.male',
  },
  {
    key: Genders.Female,
    title: 'general.female',
  },
  {
    key: Genders.Other,
    title: 'general.other',
  },
];
